'use strict';

export const ActionSets = {
    _sets: {},
    registerSet(name, set) {
        if (!this._sets[name]) {
            this._sets[name] = {};
        }
        for (const key in set) {
            this._sets[name][key] = set[key];
        }
    },
    getSet(name) {
        return this._sets[name];
    },
    async handleAction(action, payload, context = '') {
        var result = null;
        for (const set of Object.values(this._sets)) {
            if (set[action]) {
                result = await set[action](payload, context);
                if (result === false) {
                    return false; // If any set returns false, stop processing further sets
                }
            }
        }
        return result;
    }
};